import { render } from "./AuthScreen.vue?vue&type=template&id=7bdda572&scoped=true"
import script from "./AuthScreen.vue?vue&type=script&lang=js"
export * from "./AuthScreen.vue?vue&type=script&lang=js"

import "./AuthScreen.vue?vue&type=style&index=0&id=7bdda572&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bdda572"]])

export default __exports__